<template>
    <validate-form ref="form" tag="div">
        <portal to="buttons">
            <b-button variant="outline-secondary" type="reset" @click="getItem" class="mx-5 my-5">
                Annuller
            </b-button>

            <b-button @click="saveItem" variant="primary" class="mx-5 my-5">
                {{ editing ? "Gem ændringer" : "Opret kunde" }}
            </b-button>
        </portal>
        <b-form>

            <b-row>
                <b-col cols="12" md="6">
                    <b-card>
                        <b-row>
                            <b-col cols="12" md="6">
                                <FormGroup v-model="item.email" label="E-mail" rules="required|email"></FormGroup>
                            </b-col>

                            <b-col cols="12" md="6">
                                <FormGroup v-model="item.password" label="Adgangskode"></FormGroup>
                            </b-col>

                            <b-col cols="12" md="6">
                                <FormGroup label="Begrænset til butikker" rules="">
                                    <template #input="{state}">
                                        <v-select v-model="item.stores" multiple :options="$store.state.stores" placeholder="Vælg butikker" :reduce="x => x.id">
                                            <template slot="option" slot-scope="option">
                                                {{ option.name }}
                                            </template>
                                            <template slot="selected-option" slot-scope="option">
                                                {{ option.name }}
                                            </template>
                                        </v-select>
                                    </template>
                                </FormGroup>
                            </b-col>

                            <b-col cols="12" md="6">
                                <b-form-group label="Kundegrupper">
                                    <v-select v-model="item.customerRoles" multiple taggable no-drop :close-on-select="false">
                                        <template slot="option" slot-scope="option">
                                            {{ option.label }}
                                        </template>
                                        <template slot="selected-option" slot-scope="option">
                                            {{ option.label }}
                                        </template>
                                    </v-select>
                                </b-form-group>
                            </b-col>

                            <b-col cols="12" md="6">
                                <b-form-checkbox v-model="item.newsletter" switch class="my-3">
                                    Nyhedsbrev
                                </b-form-checkbox>

                                <b-form-checkbox v-model="item.inactive" switch class="my-3">
                                    Ikke aktiv
                                </b-form-checkbox>
                            </b-col>


                            <b-col cols="12" md="6">
                                <b-form-group label="Kommentar">
                                    <b-form-textarea v-model="item.comment" rows="3" />
                                </b-form-group>
                            </b-col>
                        </b-row>
                    </b-card>
                </b-col>


                <b-col cols="12" md="6">
                    <h3 class="mb-15">
                        Adresser

                        <b-button @click="addAddress" size="md" variant="outline-success" class="pa-7 float-right">
                            <feather-icon icon="PlusIcon" />
                            Tilføj adresse
                        </b-button>
                    </h3>

                    <app-collapse accordion type="margin">
                        <draggable v-model="item.addresses" class="cursor-move">
                            <app-collapse-item v-for="(address, key) in item.addresses" :key="'address-' + key" title="">
                                <template #header>
                                    <div class="position-relative w-100">
                                        <div class="primary-address">
                                            <span class="text-success mr-15" v-if="key == 0">
                                                Primær
                                                <feather-icon icon="CheckIcon" />
                                            </span>

                                            <b-button @click="item.addresses.splice(key, 1)" size="md" variant="outline-danger" class="pa-7">
                                                <feather-icon icon="TrashIcon" />
                                            </b-button>
                                        </div>

                                        <span class="lead collapse-title">
                                            <span v-if="address.isCompany">
                                                {{address.company||'Firmanavn'}}
                                            </span>
                                            <span v-else>
                                                {{address.firstName||'Fornavn'}} {{address.lastName||'Efternavn'}}
                                            </span>
                                            <br />
                                            <small>{{address.address1 ? address.address1 + ',' : ''}} {{address.zipCode}} {{address.city}}</small>
                                        </span>
                                    </div>
                                </template>
                                <b-row>
                                    <b-col cols="12">
                                        <b-form-checkbox v-model="address.isCompany" switch class="my-3">
                                            Firma
                                        </b-form-checkbox>
                                    </b-col>

                                    <b-col cols="12" md="6" v-if="!address.isCompany">
                                        <FormGroup v-model="address.firstName" label="Fornavn"></FormGroup>
                                    </b-col>
                                    <b-col cols="12" md="6" v-if="!address.isCompany">
                                        <FormGroup v-model="address.lastName" label="Efternavn"></FormGroup>
                                    </b-col>


                                    <b-col cols="12" md="6" v-if="address.isCompany">
                                        <FormGroup v-model="address.company" label="Firmanavn"></FormGroup>
                                    </b-col>
                                    <b-col cols="12" md="6" v-if="address.isCompany">
                                        <FormGroup v-model="address.vatNumber" label="CVR"></FormGroup>
                                    </b-col>
                                    <b-col cols="12" v-if="address.isCompany">
                                        <FormGroup v-model="address.attention" label="Att."></FormGroup>
                                    </b-col>


                                    <b-col cols="12" md="6">
                                        <FormGroup v-model="address.address1" label="Adresselinje 1"></FormGroup>
                                    </b-col>
                                    <b-col cols="12" md="6">
                                        <FormGroup v-model="address.address2" label="Adresselinje 2"></FormGroup>
                                    </b-col>

                                    <b-col cols="12" md="6">
                                        <FormGroup v-model="address.zipCode" label="Postnummer"></FormGroup>
                                    </b-col>
                                    <b-col cols="12" md="6">
                                        <FormGroup v-model="address.city" label="By"></FormGroup>
                                    </b-col>

                                    <!--<b-col cols="12" md="6">
                                        <FormGroup v-model="address.country" label="Land"></FormGroup>
                                    </b-col>
                                    <b-col cols="12" md="6">

                                    </b-col>-->

                                    <b-col cols="12" md="6">
                                        <FormGroup v-model="address.email" label="E-mail" vid="address.email"></FormGroup>
                                    </b-col>
                                    <b-col cols="12" md="6">
                                        <FormGroup v-model="address.phone" label="Telefon"></FormGroup>
                                    </b-col>

                                </b-row>
                            </app-collapse-item>
                        </draggable>
                    </app-collapse>

                </b-col>

            </b-row>

        </b-form>
    </validate-form>
</template>

<script>
    import Toast from '@/components/_toast.vue'

    export default {
        components: {},
        data: () => ({
            item: {
                id: null,
                addresses: []
            }
        }),
        computed: {
            id() {
                return this.$route.params.id
            },
            editing() {
                return this.id != "create"
            }
        },
        created() {
            if (this.editing) {
                this.getItem()
            } else {
                this.$store.dispatch("app/UPDATE_PAGETITLE", "Opret kunde")
            }
        },
        mounted() { },
        methods: {
            getItem() {
                if (this.editing) {
                    this.$http.get("/api/customers/" + this.id).then(x => {
                        this.item = x.data

                        this.$store.dispatch("app/UPDATE_PAGETITLE", x.data.email)
                    })
                } else {
                    this.$router.push("/customers")
                }
            },
            addAddress() {
                this.item.addresses.push({

                })
            },
            saveItem() {
                this.$refs.form.validate().then(success => {
                    if (success) {
                        this.$http.post("/api/customers/save", this.item).then(x => {

                            this.$toast({
                                component: Toast,
                                props: {
                                    title: x.data.result,
                                    icon: 'CheckCircleIcon',
                                    variant: 'success',
                                },
                            })

                            if (x.data.data) {
                                this.$router.replace({ name: "customer", params: { id: x.data.data } })
                            }

                            this.getItem()
                        })
                    }
                })
            }
        },
    }
</script>

<style scoped lang="scss" src="./customer.scss"></style>